import {
  EntityGroupDetailResponseDto,
  FeatureResponseDto,
  FeatureRuleInputDto,
  dmAdminApiInjected,
} from './dmAdminApiInjected';

enum DmAdminSliceTags {
  DEVICE_MODEL = 'DEVICE_MODEL',
  CAPABILITY_KEY = 'CAPABILITY_KEY',
  CAPABILITY_VERSION = 'CAPABILITY_VERSION',
  DEVICE_CAPABILITY = 'DEVICE_CAPABILITY',
  FEATURE = 'FEATURE',
  FEATURE_RULE = 'FEATURE_RULE',
  ENTITY_GROUP = 'ENTITY_GROUP',
  ENTITY_GROUP_MEMBER = 'ENTITY_GROUP_MEMBER',
}

// 新增／刪除 key 與 version 時，server 會連帶新增／刪除 device capability
const dmAdminApiEnhanced = dmAdminApiInjected.enhanceEndpoints({
  addTagTypes: Object.values(DmAdminSliceTags),
  endpoints: {
    capabilityControllerListDeviceModels: {
      providesTags: [DmAdminSliceTags.DEVICE_MODEL],
    },
    capabilityControllerGetDeviceModel: {
      providesTags: [DmAdminSliceTags.DEVICE_MODEL],
    },
    capabilityControllerCreateDeviceModel: {
      invalidatesTags: [DmAdminSliceTags.DEVICE_MODEL],
    },
    capabilityControllerUpdateDeviceModel: {
      invalidatesTags: [DmAdminSliceTags.DEVICE_MODEL],
    },
    capabilityControllerDeleteDeviceModel: {
      invalidatesTags: [DmAdminSliceTags.DEVICE_MODEL],
    },
    capabilityControllerListCapabilityKeys: {
      providesTags: [DmAdminSliceTags.CAPABILITY_KEY],
    },
    capabilityControllerCreateCapabilityKey: {
      invalidatesTags: [
        DmAdminSliceTags.CAPABILITY_KEY,
        DmAdminSliceTags.DEVICE_CAPABILITY,
      ],
    },
    capabilityControllerUpdateCapabilityKey: {
      invalidatesTags: [
        DmAdminSliceTags.CAPABILITY_KEY,
        DmAdminSliceTags.DEVICE_CAPABILITY,
      ],
    },
    capabilityControllerDeleteCapabilityKey: {
      invalidatesTags: [
        DmAdminSliceTags.CAPABILITY_KEY,
        DmAdminSliceTags.DEVICE_CAPABILITY,
      ],
    },
    capabilityControllerListCapabilityVersions: {
      providesTags: [DmAdminSliceTags.CAPABILITY_VERSION],
    },
    capabilityControllerCreateCapabilityVersion: {
      invalidatesTags: [
        DmAdminSliceTags.CAPABILITY_VERSION,
        DmAdminSliceTags.DEVICE_CAPABILITY,
      ],
    },
    capabilityControllerDeleteCapabilityVersion: {
      invalidatesTags: [
        DmAdminSliceTags.CAPABILITY_VERSION,
        DmAdminSliceTags.DEVICE_CAPABILITY,
      ],
    },
    capabilityControllerListDeviceCapabilities: {
      providesTags: [DmAdminSliceTags.DEVICE_CAPABILITY],
    },
    capabilityControllerUpdateDeviceCapability: {
      invalidatesTags: [DmAdminSliceTags.DEVICE_CAPABILITY],
    },
    capabilityControllerBulkUpdateDeviceCapabilities: {
      invalidatesTags: [DmAdminSliceTags.DEVICE_CAPABILITY],
    },
    capabilityControllerDeleteDeviceCapability: {
      invalidatesTags: [DmAdminSliceTags.DEVICE_CAPABILITY],
    },
    featureControllerList: {
      providesTags: [DmAdminSliceTags.FEATURE],
    },
    featureControllerGet: {
      providesTags: [DmAdminSliceTags.FEATURE],
    },
    featureControllerCreate: {
      invalidatesTags: [DmAdminSliceTags.FEATURE],
    },
    // 帶 rules 時名單也會變；group 規則會改群組的 usedBy
    featureControllerUpdate: {
      invalidatesTags: [
        DmAdminSliceTags.FEATURE,
        DmAdminSliceTags.FEATURE_RULE,
        DmAdminSliceTags.ENTITY_GROUP,
      ],
    },
    featureControllerListRules: {
      providesTags: [DmAdminSliceTags.FEATURE_RULE],
    },
    // ruleCount 在 feature 上；group 規則會改群組的 usedBy
    featureControllerAddRules: {
      invalidatesTags: [
        DmAdminSliceTags.FEATURE,
        DmAdminSliceTags.FEATURE_RULE,
        DmAdminSliceTags.ENTITY_GROUP,
      ],
    },
    featureControllerDeleteRule: {
      invalidatesTags: [
        DmAdminSliceTags.FEATURE,
        DmAdminSliceTags.FEATURE_RULE,
        DmAdminSliceTags.ENTITY_GROUP,
      ],
    },
    entityGroupControllerList: {
      providesTags: [DmAdminSliceTags.ENTITY_GROUP],
    },
    entityGroupControllerGet: {
      providesTags: [DmAdminSliceTags.ENTITY_GROUP],
    },
    entityGroupControllerCreate: {
      invalidatesTags: [DmAdminSliceTags.ENTITY_GROUP],
    },
    // 規則列表顯示群組名稱
    entityGroupControllerUpdate: {
      invalidatesTags: [
        DmAdminSliceTags.ENTITY_GROUP,
        DmAdminSliceTags.FEATURE_RULE,
      ],
    },
    entityGroupControllerDelete: {
      invalidatesTags: [DmAdminSliceTags.ENTITY_GROUP],
    },
    entityGroupControllerListMembers: {
      providesTags: [DmAdminSliceTags.ENTITY_GROUP_MEMBER],
    },
    // memberCount 在群組上，規則列表也顯示成員數
    entityGroupControllerAddMembers: {
      invalidatesTags: [
        DmAdminSliceTags.ENTITY_GROUP_MEMBER,
        DmAdminSliceTags.ENTITY_GROUP,
        DmAdminSliceTags.FEATURE_RULE,
      ],
    },
    entityGroupControllerDeleteMember: {
      invalidatesTags: [
        DmAdminSliceTags.ENTITY_GROUP_MEMBER,
        DmAdminSliceTags.ENTITY_GROUP,
        DmAdminSliceTags.FEATURE_RULE,
      ],
    },
  },
});

export type FeatureMode = FeatureResponseDto['mode'];
export type FeatureRuleType = FeatureRuleInputDto['type'];
export type EntityGroupUsedBy = EntityGroupDetailResponseDto['usedBy'][number];

export { dmAdminApiEnhanced as dmAdminApiSlice, DmAdminSliceTags };
export * from './dmAdminApiInjected';
